// mouse.js
import { ref, onMounted, onUnmounted } from "vue"
import { EventBus } from "@/eventBus"
import { ToastMessageOptions } from "primevue/toast"
import { ErrorFormat } from "../models/errorFormat"
import { useErrorHandler } from "./useErrorHandler"

// by convention, composable function names start with "use"
export function useToaster(options: SystemToastOptions) {
	EventBus.emit("systemToast", options)
}

// checked the passed in parameter to see if it has all of the properties of ErrorFormat
export function isErrorFormat(obj: any): obj is ErrorFormat {
	return (
		obj !== null &&
		typeof obj === "object" &&
		typeof obj.message === "string" &&
		typeof obj.supportMessage === "string" &&
		typeof obj.errorId === "string" &&
		typeof obj.id === "string"
	)
}

export function useErrorToaster(error: ErrorFormat | any) {
	let verifiedError: ErrorFormat
	if (isErrorFormat(error)) {
		verifiedError = error
	} else if (error && typeof error === "object" && "response" in error && isErrorFormat(error.response)) {
		verifiedError = error.response
	} else {
		verifiedError = new ErrorFormat()
		verifiedError.message = "Unknown error, please contact support"
		verifiedError.supportMessage = error
		verifiedError.errorId = "Unknown error"
		verifiedError.id = "Unknown error"
	}

	let options = new SystemToastOptions()
	options.summary = "Server Error"
	options.detail = verifiedError.message + (verifiedError.supportMessage ? "\n" + verifiedError.supportMessage : "") + "\nError ID: " + verifiedError.errorId
	options.severity = "error"
	options.life = 60000
	useErrorHandler().setErrorHandled(error)
	useToaster(options)
	console.error(`Support Error: ${verifiedError.errorId}, ${verifiedError.message}, ${verifiedError.supportMessage}`)
}

export class SystemToastOptions implements ToastMessageOptions {
	summary: string = "no summary set"
	detail: string = "no detail set"
	life?: number = 3000
	closable?: boolean = true
	contentStyleClass?: string = ""
	styleClass?: any
	severity?: "success" | "info" | "warn" | "error"
	callback?: () => void = undefined
}
